import Program1Image from "./assets/program1-img.png";
import Program2Image from "./assets/program2-img.png";

export const programData = [
  {
    id: 1,
    img: Program1Image,
    title: "Cardio and Strength",
    details:
      "Cardiovascular exercise, also called cardio or aerobic exercise, is exercise that increases your heart rate and makes your lungs work harder than normal. Strength training uses resistance to build muscle, strength, and endurance. It’s also called resistance training. ",
    imgStart: true,
    line: true,
  },
  {
    id: 2,
    img: Program2Image,
    title: "Mind and Body",
    details:
      "Group fitness is a great opportunity to practice mindfulness while also getting a good workout in but many of us prefer the weight room over the class room. If strength training makes up the majority of your fitness routine, embracing mindfulness may seem impossible. ",
    imgStart: false,
    line: true,
  },
];
